import Header from './components/Header/Header';
import Main from './components/Main/Main';
import './App.css';

function App() {
  return (
    <section className="App">
      <Header />
      <Main />
    </section>
  );
}

export default App;
